import { useContext, useEffect, useState } from "react";
import SummarySection from "../../TenantHome/SummarySection";
import AuthContext from "../../../context/auth/AuthContext";
import ProfileInfoSection from "../../TenantHome/ProfileInfoSection";
import countries from "i18n-iso-countries";
import axiosInstance from "../../../services/authWrapper";
import {
  calculateEffortRate,
  getIncomeForEffortRate,
  haveValue,
  nl2br,
} from "../../../helper/common";
import ProfessionalAcademicSection from "../../TenantHome/ProfessionalAcademicSection";
import { Accordion, Row, Col } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import EffortRateBar from "../EffortRateBar";
import LandLordContext from "../../../context/landlord/LandLordContext";

const ProfileWrapper = (props) => {
  const { user, setUser } = props;
  const { _t } = useTranslator();
  const defaultSalary = {
    salary: 0,
    matched: 0,
  };

  const { updateCreatedTenant } = useContext(LandLordContext);
  const { user: landlord_user } = useContext(AuthContext);

  const [ident_all, setIdent_all] = useState(false);
  const [intiateOnfidoTrigger, setIntiateOnfidoTrigger] = useState(false);
  const [effortObj, setEffortObj] = useState({});

  useEffect(() => {
    checkAllMatches();
    const user_income = getIncomeForEffortRate(user);
    console.log(user_income, user, "checkNamanHere");
    let temp_obj = calculateEffortRate(user_income, landlord_user, user);
    setEffortObj(temp_obj);
  }, [user]);

  const checkAllMatches = async () => {
    if (user?.onfido_kyc_success == false) {
      setIdent_all(false);
      return false;
    }

    setIdent_all(true);
    return true;
  };

  const alpha3ToName = (code) => {
    return countries.getName(code, "en");
  };

  const handleRentPercSave = (e, val) => {
    let temp_data = {
      rent_percentage: val,
      id: user?._id,
    };
    updateCreatedTenant(temp_data)
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <>
      <div id="onfido-mount"></div>

      {haveValue(user) &&
        (!haveValue(user?.onfido_kyc_success) || !user?.onfido_kyc_success) &&
        (!haveValue(user?.onfido_user_kyc?.server_status) ||
          user?.onfido_user_kyc?.server_status == "started") && (
          <div className="notify-red-bar">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M11.3 6H13.7V8.4H11.3V6ZM11.3 10.8H13.7V18H11.3V10.8ZM12.5 0C5.876 0 0.5 5.376 0.5 12C0.5 18.624 5.876 24 12.5 24C19.124 24 24.5 18.624 24.5 12C24.5 5.376 19.124 0 12.5 0ZM12.5 21.6C7.208 21.6 2.9 17.292 2.9 12C2.9 6.708 7.208 2.4 12.5 2.4C17.792 2.4 22.1 6.708 22.1 12C22.1 17.292 17.792 21.6 12.5 21.6Z"
                fill="#EF7833"
              />
            </svg>
            <p className="notify-message">
              {_t(
                "youHaventDoneTenantIdVerification",
                "ll side when tenant created by ll"
              )}
            </p>
            <button
              class="btn btndarkgreen verify-id-btn"
              onClick={(e) => setIntiateOnfidoTrigger(true)}
            >
              {_t("verifyId")}
            </button>
          </div>
        )}

      <Accordion className="primaryaccordion d-md-grid mobile-primary-accordaion">
        <Accordion.Item
          eventKey="0"
          id="profile-wrapper"
          className="mobile-document-accordion"
        >
          <Accordion.Header className="primaryaccordion-header setaccordionhead  ">
            {_t("tenantDetails")}
          </Accordion.Header>
          <Accordion.Body className="primaryaccordion-body">
            <Row>
              {haveValue(effortObj?.effort_amount) &&
                effortObj?.effort_amount != "N/A" && (
                  <Col xl={6} className="mb-3">
                    <div className="profile-summary border-pd  p-0 ">
                      <h2 className="green-bg-heading">
                        <div className="heading-icon-wrapper">
                          <img
                            className="heading-icon"
                            src="/images/green-meter.svg"
                            alt="icon"
                          />
                        </div>
                        <span>{_t("skor")}</span>
                      </h2>
                      <div className="score-content-area">
                        <p className="no-score-text">{_t("noSkorAvailable")}</p>
                        <div className="score-detail-box">
                          <EffortRateBar
                            effortObj={effortObj}
                            handleRentPercSave={handleRentPercSave}
                          />

                          <p className="d-flex justify-content-between align-items-center orange-note-box">
                            <span className="orange-note-head">
                              {_t("maximumRent")}
                            </span>
                            <span className="orange-note-price">
                              {effortObj?.effort_amount} €
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                )}

              <Col xl={6} className="mb-3">
                <div className="profile-summary border-pd  p-0 ">
                  <h2 className="green-bg-heading">
                    <div className="heading-icon-wrapper">
                      <img
                        className="heading-icon"
                        src="/images/document-icon.svg"
                        alt="icon"
                      />
                    </div>
                    <span>{_t("profileSummary")}</span>
                  </h2>

                  <p className="profile-summary-desc box-content-area">
                    {haveValue(user?.profileSummary) ? (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: nl2br(user?.profileSummary),
                        }}
                      />
                    ) : (
                      ""
                    )}
                    {!haveValue(user?.profileSummary)
                      ? _t("profileSummaryNotGenerated")
                      : ""}
                  </p>
                </div>
              </Col>
              <SummarySection
                user={user}
                ident_all={ident_all}
                recordedSalary={defaultSalary}
                haveGuarantor={false}
                isLandlord={true}
                llCreated={true}
                landlord_user={landlord_user}
                intiateOnfidoTrigger={intiateOnfidoTrigger}
                setIntiateOnfidoTrigger={setIntiateOnfidoTrigger}
              />

              {/* <Col xl={6} className="mb-3">
                <div className="profile-summary p-0 border-pd h-full">
                  <h2 className="green-bg-heading">
                    <div className="heading-icon-wrapper">
                      <img
                        className="heading-icon"
                        src="/images/profile-icon-green.svg"
                        alt="icon"
                      />
                    </div>
                    <span>{_t("defaulterChecks")}</span>
                  </h2>
                  <div className="box-content-area">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="score-progress-head">
                        {_t("probImpago")}
                      </span>
                      <span className="score-progress-score">98%</span>
                    </div>
                    <div class="progress-bar-inner-wrapper pdf-score-capsule">
                      <div class="d-flex gap-2">
                        <p class="progress-step">
                          <span
                            class="progress-fill progress-filler-dark-green"
                            style={{ width: "100%" }}
                          ></span>
                        </p>
                        <p class="progress-step">
                          <span
                            class="progress-fill progress-filler-light-green"
                            style={{ width: "100%" }}
                          ></span>
                        </p>

                        <p class="progress-step rotate-180">
                          <span
                            class="progress-fill progress-filler-yellow"
                            style={{ width: "100%" }}
                          ></span>
                        </p>

                        <p class="progress-step">
                          <span
                            class="progress-fill progress-filler-orange"
                            style={{ width: "100%" }}
                          ></span>
                        </p>

                        <p class="progress-step">
                          <span
                            class="progress-fill progress-filler-red"
                            style={{ width: "100%" }}
                          ></span>
                        </p>
                      </div>
                      <div class="d-flex justify-content-between">
                        <span class="score-limit">0%</span>
                        <span class="score-limit">100%</span>
                      </div>
                    </div>
                    <div className="grey-box-content">
                      <div className="d-flex items-start justify-content-between grey-box-point">
                        <p className="grey-box-heading">
                          <span>Fecha de Máximo Importe Impagado: </span>
                          <span className="date d-inline-block">
                            08/10/2017
                          </span>
                        </p>
                        <img
                          src="/images/tick-new.svg"
                          alt=""
                          className="green-check-icon"
                        />
                      </div>
                      <div className="d-flex items-start justify-content-between grey-box-point">
                        <p className="grey-box-heading">
                          <span>
                            Fecha de Peor Situación de Pago Histórica:{" "}
                          </span>
                          <span className="date d-inline-block">
                            08/10/2017
                          </span>
                        </p>
                        <img
                          src="/images/tick-new.svg"
                          alt=""
                          className="green-check-icon"
                        />
                      </div>
                      <div className="d-flex items-start justify-content-between grey-box-point">
                        <p className="grey-box-heading">
                          <span>
                            Fecha de Alta de la Operación más Antigua:{" "}
                          </span>
                          <span className="date d-inline-block">
                            08/10/2017
                          </span>
                        </p>
                        <img
                          src="/images/tick-new.svg"
                          alt=""
                          className="green-check-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col> */}

              <ProfileInfoSection
                user={user}
                alpha3ToName={alpha3ToName}
                userKycInfo={user?.onfido_user_kyc}
                setShowPhoneVerificationdModal={(e) => {
                  console.log("Only Valid For Tenant Profile!");
                }}
                handleRemoveGuarantor={(e) => {
                  console.log("Only Valid For Tenant Profile!");
                }}
                handleGurantorModal={(e) => {
                  console.log("Only Valid For Tenant Profile!");
                }}
                showActionPrompts={false}
                sharersData={[]}
                isLandlord={true}
                landlord_user={landlord_user}
                llCreated={true}
              />
              {haveValue(user?.employment_status) && (
                <ProfessionalAcademicSection
                  user={user}
                  recordedSalary={defaultSalary}
                  showActionPrompts={false}
                  landlord_user={landlord_user}
                  isLandlord={true}
                  llCreated={true}
                />
              )}
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default ProfileWrapper;
